module.exports = __webpack_public_path__ + "static/ice-left-7facfc99c73c2f795a14321e5bcc69f6.webp";